/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
// @ts-nocheck
import React, { Fragment, useRef } from 'react';
import ReactTooltip from 'react-tooltip';
import { FieldWrapper } from './FieldWrapper';
import useFieldApi from '@data-driven-forms/react-form-renderer/dist/cjs/use-field-api';
import { generateGridTemplate } from '../../utils/generateGridTemplate';
import clsx from 'clsx';
import { formatters } from '../../utils/formatters';
import { useTruncated } from '../../hooks/useTruncated';

export function PlainTextDDF(props) {
  const { input } = useFieldApi(props);
  const formatter = formatters[props.component];

  const value = formatter
    ? formatter({
        value: input.value,
        options: props.options,
        dateFormat: props.dateFormat
      })
    : input.value.toString() || '---';

  return (
    <PlainText
      name={input.name}
      value={value}
      label={props.label}
      className={props.className}
      labelClasses={props.labelClasses}
    />
  );
}

export function PlainText({ name, value, label, className, labelClasses }) {
  const ref = useRef<HTMLParagraphElement>(null);
  const { isTruncated } = useTruncated(ref);

  return (
    <FieldWrapper className={className} labelClasses={labelClasses} label={label}>
      <p ref={ref} data-tip={value} data-for={name} className='font-effra text-gray-40 truncate'>
        {value}
      </p>
      {isTruncated && (
        <ReactTooltip
          id={name}
          className='tooltip-custom'
          place='right'
          effect='solid'
          type='light'
          multiline
          border
          borderColor='#5b2f91'
        />
      )}
    </FieldWrapper>
  );
}

export function PlainTextArray(props) {
  return (
    <Fragment>
      {props.title && <h3>{props.title}</h3>}
      {props.description && <p>{props.description}</p>}
      <div className='flex col-span-12'>
        <div className='grid gap-8' style={{ gridTemplateColumns: generateGridTemplate(props.fields) }}>
          {props.fields.map((arrayField) => {
            const colSpan = arrayField.colSpan && !arrayField.colWidth ? arrayField.colSpan : 1;

            return (
              <div
                key={arrayField.name}
                className={clsx(
                  `mt-auto col-span-${colSpan || 1}`,
                  arrayField.colStart && `col-start-${arrayField.colStart}`
                )}
              >
                <PlainTextDDF {...arrayField} />
              </div>
            );
          })}
        </div>
      </div>
    </Fragment>
  );
}
